import { api, apiCall } from './client'
import type { ApiResponse } from '../../types'

export interface LoginData {
  email: string
  password: string
}

export interface RegisterData {
  firstName: string
  lastName: string
  email: string
  password: string
  licenseNumber: string
  phone?: string
  specialization?: string
}

export interface AuthResponse {
  user: {
    id: number
    firstName: string
    lastName: string
    email: string
    licenseNumber: string
    role: 'nurse'
  }
  accessToken: string
  refreshToken: string
  expiresIn: number
}

export const authService = {
  async login(data: LoginData): Promise<ApiResponse<AuthResponse>> {
    return apiCall(api.post<ApiResponse<AuthResponse>>('/auth/login', data))
  },

  async register(data: RegisterData): Promise<ApiResponse<AuthResponse>> {
    return apiCall(api.post<ApiResponse<AuthResponse>>('/auth/register', data))
  },

  async getProfile(): Promise<ApiResponse<AuthResponse['user']>> {
    return apiCall(api.get<ApiResponse<AuthResponse['user']>>('/auth/profile'))
  },

  async updateProfile(data: {
    firstName?: string
    lastName?: string
    email?: string
    rppsNumber?: string
    specialization?: string
    cabinetName?: string
  }): Promise<ApiResponse<AuthResponse['user']>> {
    return apiCall(
      api.patch<ApiResponse<AuthResponse['user']>>('/users/me', data)
    )
  },

  async changePassword(data: {
    currentPassword: string
    newPassword: string
    confirmPassword: string
  }): Promise<ApiResponse<void>> {
    return apiCall(api.patch<ApiResponse<void>>('/users/me/password', data))
  },

  async logout(refreshToken: string): Promise<ApiResponse<void>> {
    return apiCall(
      api.post<ApiResponse<void>>('/auth/logout', { refreshToken })
    )
  },
}

export type AuthService = typeof authService
